<template>
  <div class="NSPCC-footer">
    <div class="site-row site-row--page-footer">
        <div class="grid-wrap">
            <footer class="page-footer">

                <div class="footer-branding-item footer-branding-sportengland">
                    <p><strong>In partnership with</strong></p>
                    <a href="http://www.sportengland.org/" class="sportengland-link" target="_blank">
                        <img class="footer-logo" src="/images/sportengland-logo.png" alt="Sport England" />
                    </a>
                </div>

                <div class="footer-branding-item footer-branding-childline">
                    <p><strong>Help for children &amp; young people</strong></p>
                    <a href="http://www.childline.org.uk/" class="chidline-link" target="_blank">
                        <img class="footer-logo" src="/images/childline-logo.png" alt="Childline" />
                    </a>
                </div>

                <div class="footer-branding-item footer-branding-nspcc">
                    <p><strong>Help for adults concerned about a child</strong></p>
                    <a href="http://www.nspcc.org.uk/" class="nspcc-link" target="_blank">
                        <img class="footer-logo" src="/images/nspcc-logo.png" alt="NSPCC" />
                    </a>
                </div>

                <div class="footer-content-wrap">

                    

                    <nav class="footer-nav">
                        <section class="linksList collapsible">
                          <!-- <h2>Links</h2> -->
                          <div class="cmenu">
                            <ul>
                              <li v-for="page in footer.Items" :key="page.PageName">
                                <a class="nav-item" :href="page.PageUrl">{{ page.PageName }}</a><span>|</span>
                              </li>
                              <li><a class="nav-item ot-sdk-show-settings">Manage cookies</a></li>
                            </ul>
                          </div>
                        </section>
                        
                    </nav>

                        <div class="footer-content" v-html="footer.FooterText">
                        </div>                   

                </div>
            </footer>
        </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex"

export default {
  name: "FooterBar",
  data() {
    return {
      footer: Object
    };
  },
  async created() {
    this.footer = await this.getFooterNav();
  },
   methods: {
    ...mapActions("util", ["getFooterNav"]),
   }
};
</script>
<style lang="scss">
@import "@/assets/sass/variables.scss";
@import "@/assets/sass/mixins.scss";
@import "@/assets/sass/typography.scss";
@import "@/assets/sass/footer.scss";
</style>
